const isPlayer = accountType => {
    return accountType === 'player';
}

export default isPlayer;

